import { createActions } from 'reduxsauce'

const { Types, Creators } = createActions({
  getWirecardInfo: ['pdn', 'startDate', 'endDate'],
  getWirecardInfoLoading: null,
  getWirecardInfoSuccess: ['res'],
  getWirecardInfoFailure: ['error'],

  cleanWirecardState: null

}, { prefix: 'WIRECARD_' })

export const WirecardTypes = Types

export default Creators
